<template>
  <SysDialog
    v-model="dialog"
    titulo="Filial de destino X Filiais de origem"
    @click:primary="editarDados()"
  >
    <template #ativador>
      <v-btn icon @click="abrirDialog()">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-autocomplete
      v-model="exibicao.grupos_separacao"
      :items="selects.grupos_separacao"
      label="Grupos de Separação"
      outlined
      disabled
      item-value="id"
      item-text="descricao"
      :error-messages="GRUPO_SEPARACAO_ERRORS"
      @input="$v.exibicao.grupos_separacao.$touch()"
    />

    <SysFilialGrupoAutocomplete
      v-model="exibicao.filial_destino"
      label="Filial Destino"
      item-text="filial"
      item-value="filial"
      outlined
      disabled
      :error-messages="FILIAL_DESTINO_ERROS"
      @input="$v.exibicao.filial_destino.$touch()"
    />

    <DivisorComLegenda legenda="Filiais de origem e parametrização" class="mb-6" />

    <v-row v-for="(vl, idx) in exibicao.multi" :key="idx">
      <v-col :class="idx+1 == exibicao.multi.length ? 'mb-5' : ''">
        <SysFilialGrupoAutocomplete
          v-model="vl.filial_origem"
          label="Filial Origem"
          item-text="descricao"
          item-value="filial"
          outlined
          hide-details
          multiple
          :disabled="vl.desativar"
        />
      </v-col>

      <v-col :class="idx+1 == exibicao.multi.length ? 'mb-5' : ''">
        <TextFieldFormatadorDeValor
          v-model="vl.cobertura_drp"
          label="Cobertura de Estoque"
          outlined
          suffix="dias"
          hide-details
          :removerValorIrrelevante="true"
        />
      </v-col>

      <v-col :class="idx+1 == exibicao.multi.length ? 'mb-5' : ''">
        <TextFieldFormatadorDeValor
          v-model="vl.tempo_ressuprimento_drp"
          label="Tempo Ressuprimento"
          outlined
          suffix="dias"
          hide-details
          :removerValorIrrelevante="true"
        />
      </v-col>

      <v-btn icon @click="removerFilialOrigem(idx)" class="my-auto" v-if="FILIAL_ORIGEM_LENGH > 1">
        <v-icon color="red">mdi-minus</v-icon>
      </v-btn>
    </v-row>

    <v-btn icon class="mt-n2" @click="adicionarFilialOrigem()">
      <v-icon color="primary">mdi-plus</v-icon>
    </v-btn>
  </SysDialog>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import { getGrupoSeparacao, updateMapaSeparacao, deleteFilialGrupoSeparacao } from './Requisicoes';
import { required } from "vuelidate/lib/validators";
import {arrayColumn} from "@/helpers";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  components: {DivisorComLegenda, SysDialog, SysFilialGrupoAutocomplete, TextFieldFormatadorDeValor },
  props: {
    item: { type: Object, required: true }
  },
  data: ()=> ({
    dialog: false,
    selects: {
      grupos_separacao: []
    },
    exibicao: {
      grupos_separacao: '',
      filial_destino: '',
      multi: []
    }
  }),
  created() {
    this.buscarGruposDeSeparacao();
  },
  mounted() {
    this.aplicarValoresEditar();
  },
  watch: {
    item() {
      this.aplicarValoresEditar();
    }
  },
  computed: {
    GRUPO_SEPARACAO_ERRORS () {
      const errors = [];
      if (!this.$v.exibicao.grupos_separacao.$dirty) return errors;
      !this.$v.exibicao.grupos_separacao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_DESTINO_ERROS () {
      const errors = [];
      if (!this.$v.exibicao.filial_destino.$dirty) return errors;
      !this.$v.exibicao.filial_destino.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_ORIGEM_LENGH() {
      return this.exibicao.multi.length;
    }
  },
  methods: {
    removerFilialOrigem(idx) {
      if (this.FILIAL_ORIGEM_LENGH == 1) return;

      const parametros = {
        grupo_separacao: this.exibicao.grupos_separacao,
        filial_destino: this.exibicao.filial_destino,
        filial_origem: this.exibicao.multi[idx].filial_origem[0]
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        deleteFilialGrupoSeparacao(parametros)
          .then(() => {
            this.$emit('atualizar-tela-inicial');
            this.exibicao.multi.splice(idx, 1)
          })
          .catch(() => this.Helpers.logout())
      );
    },
    adicionarFilialOrigem() {
      this.exibicao.multi.push({
        filial_origem: '',
        cobertura_drp: 30,
        tempo_ressuprimento_drp: 5,
        desativar: false
      });
    },
    aplicarValoresEditar() {
      const filiais_origem = this.item.filiais_origem;
      const cobertura_drp = arrayColumn(this.item.coberturas, 'cobertura');
      const tempo_ressuprimento_drp = arrayColumn(this.item.tempos_ressuprimento, 'tempo_ressuprimento');

      this.exibicao = {
        grupos_separacao: parseInt(this.item.id_grupo_separacao),
        filial_destino: parseInt(this.item.filial_destino),
        multi: []
      };

      for (let index = 0; index < filiais_origem.length; index++) {
        this.exibicao.multi.push({
          filial_origem: [parseInt(filiais_origem[index])],
          cobertura_drp: cobertura_drp[index],
          tempo_ressuprimento_drp: tempo_ressuprimento_drp[index],
          desativar: true
        });
      }
    },
    editarDados() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        updateMapaSeparacao(this.exibicao)
          .then(() => {
            this.$emit('atualizar-tela-inicial');
            this.fecharDialog();
          })
          .catch(() => this.Helpers.logout())
      );
    },
    buscarGruposDeSeparacao() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getGrupoSeparacao()
          .then(grupos => this.selects.grupos_separacao = grupos)
          .catch(() => this.Helpers.logout())
      );
    },
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
  },
  validations: {
    exibicao: {
      grupos_separacao: { required },
      filial_destino: { required },
      multi: { required }
    }
  },
}
</script>

<style>

</style>
